// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1631":"99d5c7da","1741":"99d5c7da","7894":"99d5c7da","8165":"99d5c7da","9332":"99d5c7da"}[chunkId] + ".chunk.css";
};